import { Component, OnInit, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-business-partner-search-popup',
  templateUrl: './business-partner-search-popup.component.html',
  styleUrls: ['./business-partner-search-popup.component.scss']
})
export class BusinessPartnerSearchPopupComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<BusinessPartnerSearchPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }
  closePopup(data: string) {

    this.dialogRef.close({ data });
  }

}
